import { Action } from "redux";

export type ExportAppErase = "EXPORT_APP_ERASE";
export const EXPORT_APP_ERASE: ExportAppErase = "EXPORT_APP_ERASE";

export interface ExportAppEraseAction extends Action {
    type: ExportAppErase;
}

export function exportAppErase(): ExportAppEraseAction {
    return {
        type: EXPORT_APP_ERASE
    };
}
